var map = {
	"./1.svg": 466,
	"./10.svg": 467,
	"./2.svg": 468,
	"./3.svg": 469,
	"./4.svg": 470,
	"./5.svg": 471,
	"./6.svg": 472,
	"./7.svg": 473,
	"./8.svg": 474,
	"./9.svg": 475
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/level_icons ^\.\/.*\.svg$
// module id = 184
// module chunks = 4